<template>
    <div>
        <label for="localidad">{{ $t('formularios.localidad') }}</label>
        <ValidationProvider name="localidad" rules="required" v-slot="{ errors }">
            <template v-if="locations.length > 0">
                <multiselect
                    :disabled="desactivar"
                    v-model="selected"
                    :placeholder="$t('formularios.localidad')"
                    label="nombre"
                    track-by="id"
                    :options="locations"
                    :multiple="false"
                    v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
                ></multiselect>
            </template>
            <template v-else>
                <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Localidad" v-model="selected.nombre" @change="() => $emit('selected', selected)">
            </template>

            <span v-if="errors[0]" class="invalid-feedback" style="display: block;">{{ errors[0] }}</span>
        </ValidationProvider>
    </div>
</template>

<script>

export default {
    props: ['provincia', 'location_id', 'errors', 'desactivar'],
    data() {
        return {
            locations: [],
            selected: {}
        }
    },
    created() {
        if(this.location_id) {
            this.selected = this.location_id;
        }

        if(this.provincia) {
            if(this.provincia.localidades) {
                this.locations = this.provincia.localidades;
            } else {
                this.getLocations(this.provincia);
            }

        }
    },
    watch: {
        provincia: function(newVal, oldVal) {
            if(newVal === null) {
                locations = [];
            } else if(newVal !== oldVal) {
                if(newVal.localidades) {
                    this.locations = newVal.localidades;
                } else {
                    this.getLocations(newVal);
                }

                if(newVal.localidades && newVal.localidades.length > 0) {
                    this.selected = null;
                } else {
                    this.selected = {};
                }
            }
        }
    },
    methods: {
        getLocations(provincia) {
            if(provincia == null) {
                this.locations = [];
                return;
            }

            const data = {
                filters: {
                    provincia_id: provincia.id
                },
            };

            this.$store.dispatch(this.config.getVuexAlias('select.locations'), data).then(res => {
                this.locations = res.data.data;
            });
        }
    }
}
</script>
